(function($) {


  // Mobile menu toggles
  $('.navigation-toggle').on('click', function() {
    var $t = $(this);

    // Toggle button class
    $t.toggleClass('active');

    // Toggle target element class
    $($t.attr('data-target'))
      .toggleClass('active');
  });


  /**
   * Mobile submenu toggling
   */
  $('.menu > li').on('click', function(e) {
    if(e.target.tagName === 'LI') {
      var wasOpen = $(this).find('.sub-menu').hasClass('open');

      $('.menu > li.open, .sub-menu.open').removeClass('open');

      if(!wasOpen) {
        $(this).addClass('open').find('.sub-menu').addClass('open');
      }
    }
    e.stopPropagation();
  });


  // highlights
  $(document).ready(function() {
    $('.type-highlight_imgntext:odd').addClass('odd');
    $('.type-highlight_imgntext:even').addClass('even');
  });

  function supports_history_api() {
    return !!(window.history && history.pushState);
  }

  // @see https://stackoverflow.com/a/19472410
  function replaceQueryParam(param, newval, search) {
    var regex = new RegExp("([?;&])" + param + "[^&;]*[;&]?");
    var query = search.replace(regex, "$1").replace(/&$/, '');

    return (query.length > 2 ? query + "&" : "?") + (newval ? param + "=" + newval : '');
  }

  // forms
  $('.select-form button').on('click', function() {
    var $t = $(this);

    $('.select-form button').removeClass('active');
    // Toggle button class
    $t.toggleClass('active');

    $('.available-forms .js-form').removeClass('active');
    // Toggle target element class
    $($t.attr('data-target')).toggleClass('active');

    if (supports_history_api()) {
      var current_url = location.protocol + '//' + location.host + location.pathname;

      form_arg = $t.attr('data-form');

      var new_url = current_url + replaceQueryParam('form', form_arg, location.search);
      window.history.replaceState(new_url, document.title, new_url);
    }


  });

  var confirm_message = $('.gform_confirmation_wrapper');
  confirm_message.parent().addClass('active');

  $(document).ready(function($){
    $('.osio__palsta').each(function(){
      var height = $(this).find('.kuvaus-container').prop('offsetHeight');
      var textHeight = $(this).find('.kuvaus').prop('scrollHeight');

      if(textHeight > height){
      $(this).find('.painike.open').addClass('show');
      }
    });

    $('.osio__palsta .painike').on('click', function(){
      $(this).parent('.osio__palsta').find('.kuvaus').toggleClass('showall');
      $(this).parent('.osio__palsta').find('.painike.open').toggle();
      $(this).parent('.osio__palsta').find('.painike.close').toggleClass('show');
    });
  });

})(jQuery);
